import { CModal, CModalBody } from '@coreui/react';
import { FaTimes } from 'react-icons/fa';

const ReportModal = ({
  isOpen = false,
  onClose,
  title = '',
  subtitle = '',
  size = 'lg',
  modalMode = 'Add', // 'Add' | 'Edit' | 'View'
  isFormValid = true,
  isSubmitting = false,
  onSubmit,
  onUpdate,
  submitButtonLabel = 'Submit',
  updateButtonLabel = 'Update',
  closeButtonLabel = 'Close',
  cancelButtonLabel = 'Cancel',
  children,
  footerExtra,
}) => {
  return (
    <CModal
      show={isOpen}
      onClose={onClose}
      centered
      size={size}
      className="[&_.modal-content]:border-0 [&_.modal-content]:rounded-xl [&_.modal-content]:shadow-2xl [&_.modal-content]:overflow-hidden"
    >
      <CModalBody className="p-6 text-aimhi-textlight-neutral font-sans">
        {/* Header */}
        <div className="flex items-start justify-between gap-3 mb-3 pb-3 border-b border-gray-100">
          <div>
            <h2 className="text-base font-bold text-aimhi-textlight-neutral m-0">{title}</h2>
            {subtitle && <p className="text-xs text-aimhi-textlight-muted m-0 mt-0.5">{subtitle}</p>}
          </div>
          <button
            type="button"
            className="text-gray-400 hover:text-aimhi-textlight-neutral p-1 rounded-md hover:bg-gray-100 transition-colors cursor-pointer -mr-1.5 -mt-1.5"
            onClick={onClose}
            aria-label="Close"
          >
            <FaTimes size={13} />
          </button>
        </div>

        {/* Modal Body / Custom Content */}
        {children}

        {/* Modal Footer */}
        <div className="flex justify-end items-center gap-2.5 mt-6 pt-4 border-t border-gray-100">
          {footerExtra}

          <button
            type="button"
            className="inline-flex items-center justify-center min-w-[84px] h-9 px-4 text-xs font-semibold rounded-md border border-gray-300 bg-white text-aimhi-textlight-neutral hover:bg-aimhi-light transition-colors cursor-pointer"
            onClick={onClose}
          >
            {modalMode === 'View' ? closeButtonLabel : cancelButtonLabel}
          </button>

          {modalMode === 'Edit' && onUpdate && (
            <button
              type="button"
              className="inline-flex items-center justify-center min-w-[84px] h-9 px-4 text-xs font-semibold rounded-md border border-transparent bg-aimhi-textlight-neutral text-white hover:bg-[#344759] transition-colors cursor-pointer shadow-sm disabled:opacity-50 disabled:cursor-not-allowed"
              disabled={!isFormValid || isSubmitting}
              onClick={onUpdate}
            >
              {updateButtonLabel}
            </button>
          )}

          {modalMode === 'Add' && onSubmit && (
            <button
              type="button"
              className="inline-flex items-center justify-center min-w-[84px] h-9 px-4 text-xs font-semibold rounded-md border border-transparent bg-aimhi-textlight-neutral text-white hover:bg-[#344759] transition-colors cursor-pointer shadow-sm disabled:opacity-50 disabled:cursor-not-allowed"
              disabled={!isFormValid || isSubmitting}
              onClick={onSubmit}
            >
              {submitButtonLabel}
            </button>
          )}
        </div>
      </CModalBody>
    </CModal>
  );
};


export default ReportModal;
